import {
  DataTableCell,
  Table,
  TableBody,
  TableCell,
  TableHeader,
} from "@david.kucsai/react-pdf-table";
import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { format, parseISO } from "date-fns";
import { fontSemiBold } from "../../../../utils/fontWeight";

export const pdfStyles = StyleSheet.create({
  page: {
    margin: 10,
    padding: 10,
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  section: {
    marginLeft: 0,
    marginRight: 20,
    padding: 5,
    flexGrow: 1,
  },
  title: {
    fontSize: 14,
    marginBottom: 6,
    ...fontSemiBold,
  },
  period: {
    fontSize: 11,
    marginBottom: 10,
  },
  tableCell: {
    padding: 3,
    fontSize: 9,
    ...fontSemiBold,
  },
  dataTableCell: {
    padding: 3,
    fontSize: 9,
  },
  totals: {
    marginTop: 12,
    fontSize: 10,
  },
  totalsLine: {
    marginBottom: 3,
  },
  empty: {
    fontSize: 10,
    marginTop: 8,
  },
});

export function formatCurrency(value) {
  const amount = Number(value) || 0;
  return amount.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatDate(value) {
  if (!value) return "—";
  try {
    const iso = String(value).includes("T")
      ? String(value)
      : `${String(value).slice(0, 10)}T00:00:00`;
    return format(parseISO(iso), "dd/MM/yyyy");
  } catch {
    return String(value);
  }
}

export function formatMonthLabel(row) {
  const label = row?.label || "";
  const year = row?.year;
  if (label && year) return `${label}/${year}`;
  if (label) return label;
  if (row?.month && year) return `${row.month}/${year}`;
  return "—";
}

export function ReportPeriodHeader({ title, from, to }) {
  return (
    <View style={{ marginBottom: 8 }}>
      <Text style={pdfStyles.title}>{title}</Text>
      {(from || to) && (
        <Text style={pdfStyles.period}>
          Período: de{" "}
          <Text style={{ ...pdfStyles.period, ...fontSemiBold }}>
            {from ? formatDate(from) : "—"}
          </Text>{" "}
          até{" "}
          <Text style={{ ...pdfStyles.period, ...fontSemiBold }}>
            {to ? formatDate(to) : "—"}
          </Text>
        </Text>
      )}
    </View>
  );
}

export function ReportTable({ columns, rows }) {
  if (!rows?.length) {
    return (
      <Text style={pdfStyles.empty}>Nenhum registro no período selecionado.</Text>
    );
  }

  return (
    <Table data={rows}>
      <TableHeader>
        {columns.map((col) => (
          <TableCell key={col.key} style={pdfStyles.tableCell}>
            {col.header}
          </TableCell>
        ))}
      </TableHeader>
      <TableBody>
        {columns.map((col) => (
          <DataTableCell
            key={col.key}
            style={pdfStyles.dataTableCell}
            getContent={(r) => col.getContent(r)}
          />
        ))}
      </TableBody>
    </Table>
  );
}

export function ReportTotals({ lines }) {
  if (!lines?.length) return null;
  return (
    <View style={pdfStyles.totals}>
      {lines.map((line) => (
        <Text key={line.label} style={pdfStyles.totalsLine}>
          <Text style={fontSemiBold}>{line.label}: </Text>
          {line.value}
        </Text>
      ))}
    </View>
  );
}
